import Vue from 'vue'
import Router from 'vue-router'

import Menu from '@/components/Menu'
import WordList from '@/components/WordList'
import WordDetail from '@/components/WordDetail'
import QuestionList from '@/components/QuestionList'
import QuestionDetail from '@/components/QuestionDetail'
import QuestionAnswer from '@/components/QuestionAnswer'
import QuestionResult from '@/components/QuestionResult'
import QuestionResultPerfect from '@/components/QuestionResultPerfect'
import PracticeList from '@/components/PracticeList'
import PracticeChapter from '@/components/PracticeChapter'
import PracticeDetail from '@/components/PracticeDetail'
import PracticeAnswer from '@/components/PracticeAnswer'
import PracticeAnswerList from '@/components/PracticeAnswerList'
import MovieList from '@/components/MovieList'
import MovieDetail from '@/components/MovieDetail'
import WebGisList from '@/components/WebGisList'
import WebGisDetail from '@/components/WebGisDetail'
import MapList from '@/components/MapList'
import MapDetail from '@/components/MapDetail'
import Timeline from '@/components/Timeline'
import LinkList from '@/components/LinkList'
import LawList from '@/components/LawList'
import LawDetail from '@/components/LawDetail'
import ImageList from '@/components/ImageList'
import ImageDetail from '@/components/ImageDetail'
import SampleList from '@/components/SampleList'
import SampleDetail from '@/components/SampleDetail'
import SampleDetail2 from '@/components/SampleDetail2'
import GeographList from '@/components/GeographList'
import GeographDetail from '@/components/GeographDetail'
import ProjectionList from '@/components/ProjectionList'
import ProjectionDetail from '@/components/ProjectionDetail'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: process.env.TITLE,
      component: Menu
    },

    {
      path: '/word',
      name: '用語解説',
      component: WordList
    },
    {
      path: '/wordDetail',
      name: '用語解説',
      component: WordDetail
    },

    {
      path: '/question',
      name: '一問一答',
      component: QuestionList
    },
    {
      path: '/questionDetail',
      name: '問題',
      component: QuestionDetail
    },
    {
      path: '/questionAnswer',
      name: '回答',
      component: QuestionAnswer
    },
    {
      path: '/questionResult',
      name: '結果',
      component: QuestionResult
    },
    {
      path: '/questionResultPerfect',
      name: '結果',
      component: QuestionResultPerfect
    },

    {
      path: '/practice',
      name: '演習問題',
      component: PracticeList
    },
    {
      path: '/practiceChapter',
      name: '演習問題',
      component: PracticeChapter
    },
    {
      path: '/practiceDetail',
      name: '演習問題',
      component: PracticeDetail
    },
    {
      path: '/practiceAnswer',
      name: '演習問題',
      component: PracticeAnswer
    },
    {
      path: '/practiceAnswerList',
      name: '演習問題',
      component: PracticeAnswerList
    },

    {
      path: '/movie',
      name: '動画',
      component: MovieList
    },
    {
      path: '/movieDetail',
      name: '動画',
      component: MovieDetail
    },

    {
      path: '/gis',
      name: 'WebGIS',
      component: WebGisList
    },
    {
      path: '/gisDetail',
      name: 'WebGIS',
      component: WebGisDetail
    },

    {
      path: '/link',
      name: '学習に役立つリンク集',
      component: LinkList
    },


    {
      path: '/map',
      name: '地図',
      component: MapList
    },
    {
      path: '/mapDetail',
      name: '地図',
      component: MapDetail
    },

    {
      path: '/timeline',
      name: '年表',
      component: Timeline
    },

    {
      path: '/link',
      name: '外部団体へのリンク',
      component: LinkList
    },

    {
      path: '/law',
      name: '法令集',
      component: LawList
    },
    {
      path: '/lawDetail',
      name: '法令集',
      component: LawDetail
    },

    {
      path: '/image',
      name: '図版',
      component: ImageList
    },
    {
      path: '/imageDetail',
      name: '地図',
      component: ImageDetail
    },

    {
      path: '/sample',
      name: '判例',
      component: SampleList
    },
    {
      path: '/sampleDetail',
      name: '判例',
      component: SampleDetail
    },
    {
      path: '/sampleDetail2',
      name: '判例',
      component: SampleDetail2
    },

    {
      path: '/geographical',
      name: '地理院地図で見てみよう',
      component: GeographList
    },
    {
      path: '/geographicalDetail',
      name: '地理院地図で見てみよう',
      component: GeographDetail
    },

    {
      path: '/projection',
      name: 'さまざまな時代の地図・地図投影法',
      component: ProjectionList
    },
    {
      path: '/projectionDetail/:id',
      name: 'projectionDetail',
      component: ProjectionDetail
    },

  ]
})

//titleタグ
//document.title = process.env.TITLE



// WEBPACK FOOTER //
// ./src/router/index.js